export default {
  meta: {
    title: $localize`:@@meta.privacy_policy.title:Политика конфиденциальности → CSFAIL`,
    description: $localize`:@@meta.privacy_policy.desc:Внимательно ознакомьтесь с настоящей политикой конфиденциальности проекта CSFAIL, до начала использования сайта и его программных средств`
  }
};